<ng-container *ngIf="courses">
    <div class="course-card">
        <div class="card">
            <ng-container *ngIf="enableAdd; then addTemplate else DefaultTemplate"></ng-container>
            <ng-template #addTemplate>
                <div class="card-body">
                    <form [formGroup]="CourseForm">
                        <mat-form-field class="full-width">
                            <mat-label>Название курса</mat-label>
                            <input formControlName="name" matInput name="name" placeholder="Ex. Курс по Sql" value="">
                        </mat-form-field>
                        <mat-form-field class="full-width">
                            <mat-label>Описание курса</mat-label>
                            <textarea formControlName="description" matInput name="description" placeholder="Ex. Курс посвящен..."></textarea>
                        </mat-form-field>
                        <mat-form-field class="full-width">
                            <mat-label>Рейтинг (звезды)</mat-label>
                            <input formControlName="stars" matInput placeholder="От 0 до 5"  type="number" min="0" max="5" name="stars" value="">
                        </mat-form-field>
                        <mat-form-field class="full-width">
                            <mat-label>Теги</mat-label>
                            <input formControlName="tags" matInput name="tags" placeholder="Ex. sqlite, golang" value="">
                        </mat-form-field>
                        <br>
                        <button mat-raised-button (click)="enableAdd=false" ng-click="cancel()">Cancel</button>
                        <button mat-raised-button (click)="AddCourse()" type="submit">Save</button>
                    </form>
                </div>
            </ng-template>
            <ng-template #DefaultTemplate>
                <div class="card-body default">
                    <button (click)="openAddForm()" mat-fab color="primary" aria-label="Создать новый курс">
                        <mat-icon>add</mat-icon>
                    </button>
                    <input
                    style="display: none"
                    type="file" (change)="onFileChanged($event)"
                    #fileInput>
                    <button mat-fab color="primary"  aria-label="Загрузить новый курс" (click)="fileInput.click()"><mat-icon>insert_drive_file</mat-icon></button>
                </div>
            </ng-template>
        </div>
        <div *ngFor="let course of courses; index as i;" class="card">
            <div class="card-body">
            <ng-container *ngIf="enableEdit && enableEditIndex == i; else courseTemplate">
                <form [formGroup]="CourseForm">
                    <mat-form-field class="full-width">
                        <mat-label>Название курса</mat-label>
                        <input formControlName="name" matInput name="name" placeholder="Ex. Курс по Sql" value="{{course.name}}">
                    </mat-form-field>
                    <mat-form-field class="full-width">
                        <mat-label>Описание курса</mat-label>
                        <textarea formControlName="description" matInput name="description" placeholder="Ex. Курс посвящен...">{{course.description}}</textarea>
                    </mat-form-field>
                    <mat-form-field class="full-width">
                        <mat-label>Рейтинг (звезды)</mat-label>
                        <input formControlName="stars" matInput placeholder="От 0 до 5"  type="number" min="0" max="5" name="stars" value="{{course.stars}}">
                    </mat-form-field>
                    <mat-form-field class="full-width">
                        <mat-label>Теги</mat-label>
                        <input formControlName="tags" matInput name="tags" placeholder="Ex. sqlite, golang" value="{{course.tags}}">
                    </mat-form-field>
                    <br>
                    <button mat-raised-button (click)="enableEdit=false" ng-click="cancel()">Cancel</button>
                    <button mat-raised-button (click)="SaveEdit(course.id, i)" type="submit">Save</button>
                </form>
            </ng-container>
            <ng-template #courseTemplate>
                <div class="name">
                    <h5>{{course.name}}</h5>
                    <mat-slide-toggle [(ngModel)]="course.private" (change)="changePrivate(course.id)">Приватный</mat-slide-toggle>
                </div> 
                <h6 class="card-subtitle mb-2 text-muted">{{course.subname}}</h6>
                <p class="card-text">{{course.description}}</p>
                <div class="stars" >
                    <ng-container *ngFor='let key of course.stars | numberToArray'><i class="fas fa-star"></i></ng-container> 
                    <ng-container *ngFor='let key of 5-course.stars | numberToArray'><i class="far fa-star"></i></ng-container> 
                </div>
                <h6 class="card-subtitle mb-2 text-muted">{{course.tags}}</h6>
                <button (click)="openEditForm(i, course)" mat-raised-button>Редактировать</button>
                <a [routerLink]="['/admin/course', course.id]" class="insidecourse">Перейти</a>
                <button color="warn" (click)="deleteCourse(course.id, i)" mat-raised-button>Delete</button>
            </ng-template>
            </div>
        </div>
        
    </div>
</ng-container>
